<form #form="ngForm" novalidate
    class="form-wizard-step"
    [class.first-step]="isFirstStep">
    <div class="form-wizard-step-header">
        <h4 class="form-wizard-step-title">
            Funil de Vendas
        </h4>
        <p class="form-wizard-step-text">
            Selecione para qual funil de vendas e fase este novo negócio deve ser criado.
        </p>
    </div>

    <div class="form-wizard-step-content">
        <div class="row">
            <div class="form-group col-12 col-md">
                <sgt-funil-venda-select
                    [funilVenda]="funilVenda"
                    [idFunilVenda]="idFunilVenda"
                    (funilVendaChange)="onChangeFunilVenda($event)"
                    [tiposFunilVendaFasesFilter]="tiposFunilVendaFasesFilter"
                    [isShowTitle]="true"
                    [isShowNull]="false"
                    [disabled]="!canEditFunilVenda">
                </sgt-funil-venda-select>
            </div>
            <div class="form-group col-12 col-md" *ngIf="funilVenda">
                <sgt-funil-venda-fase-select
                    [fases]="funilVenda.fases"
                    [funilVendaFase]="funilVendaFase"
                    [idFunilVendaFase]="idFunilVendaFase"
                    [tipoFunilVendaFase]="tipoFunilVendaFase"
                    (funilVendaFaseChange)="onChangeTipoFunilVendaFase($event)"
                    [isShowTitle]="true"
                    [isShowNull]="false"
                    [disabled]="!canEditFunilVendaFase">
                </sgt-funil-venda-fase-select>     
            </div>       
        </div>     
    </div>

    <div class="form-wizard-step-actions">     
        <button type="button" class="btn btn-sm btn-light" (click)="previus.emit()" *ngIf="!isFirstStep">
            <i class="fas fa-arrow-left"></i> Voltar
        </button>
           
        <button type="button" class="btn btn-sm btn-primary" (click)="nextClick()" [disabled]="form.invalid">
            Avançar <i class="fas fa-arrow-right"></i>
        </button>
    </div>
</form>